import { render, staticRenderFns } from "./tabbarEdit.vue?vue&type=template&id=14f8e1e7"
import script from "./tabbarEdit.vue?vue&type=script&lang=js"
export * from "./tabbarEdit.vue?vue&type=script&lang=js"
import style0 from "./tabbarEdit.vue?vue&type=style&index=0&id=14f8e1e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports